import React, { useContext } from "react";
import { CloseIcon, SearchIcon } from "../../assets/Icons";
import { SearchProviderContext } from "../../contexts/SearchProviderContext";
import {
  SearchContainer,
  SearchInput,
  SearchInputWrapper,
  SearchResult,
  TrailingIcon
} from "./styles";

type SearchBarProps = {
  tabIndex: number;
};

const SearchBar = (props: SearchBarProps) => {
  const { term, setTerm, filteredProviders } = useContext(
    SearchProviderContext
  );
  const tabIndex = props.tabIndex ?? 1;

  const updateSearch = (value: string) => {
    setTerm(value);
  };

  const resetSearch = () => {
    setTerm("");
  };

  return (
    <SearchContainer>
      <SearchInputWrapper>
        <TrailingIcon
          title={term ? "Limpar busca" : "Buscar"}
          tabIndex={term ? tabIndex + 1 : -1}
          onClick={resetSearch}
        >
          {term ? <CloseIcon /> : <SearchIcon />}
        </TrailingIcon>

        <SearchInput
          type="text"
          maxLength={30}
          tabIndex={tabIndex}
          value={term}
          onChange={e => updateSearch(e.currentTarget.value)}
          name="Campo de busca"
          title="Busque sua operadora"
          placeholder="Busque sua operadora"
        />
      </SearchInputWrapper>

      {term && (
        <SearchResult>
          {filteredProviders.length} resultado
          {filteredProviders.length > 1 ? "s" : ""} de busca para "{term}"
        </SearchResult>
      )}
    </SearchContainer>
  );
};

export default SearchBar;
